import React from 'react';
import { Grid } from '@mui/material';
import AllInboxIcon from '@mui/icons-material/AllInbox';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import SupportStatCard from './SupportStatCard';

/**
 * @param {{
 *   selectedStatus: import('../../types/support').SupportStatusFilter;
 *   counts: { all: number; waiting: number; inProgress: number; done: number };
 *   isLoading: boolean;
 *   onStatusChange: (status: import('../../types/support').SupportStatusFilter) => void;
 * }} props
 */
export default function SupportStatsCards({ selectedStatus, counts, isLoading, onStatusChange }) {
  const cards = [
    {
      title: 'Todos os chamados',
      value: counts.all,
      icon: <AllInboxIcon />,
      status: /** @type {import('../../types/support').SupportStatusFilter} */ ('Todos os chamados'),
    },
    {
      title: 'Em espera',
      value: counts.waiting,
      icon: <HourglassEmptyIcon />,
      status: /** @type {import('../../types/support').SupportStatusFilter} */ ('Em espera'),
    },
    {
      title: 'Em andamento',
      value: counts.inProgress,
      icon: <AutorenewIcon />,
      status: /** @type {import('../../types/support').SupportStatusFilter} */ ('Em andamento'),
    },
    {
      title: 'Concluídos',
      value: counts.done,
      icon: <CheckCircleOutlineIcon />,
      status: /** @type {import('../../types/support').SupportStatusFilter} */ ('Concluídos'),
    },
  ];

  return (
    <Grid container spacing={2} sx={{ mb: 2 }}>
      {cards.map((card) => (
        <Grid item xs={12} sm={6} md={3} key={card.title} sx={{ display: 'flex' }}>
          <SupportStatCard
            title={card.title}
            value={card.value}
            icon={card.icon}
            active={selectedStatus === card.status}
            isLoading={isLoading}
            onClick={() => onStatusChange(card.status)}
          />
        </Grid>
      ))}
    </Grid>
  );
}
